import { getExerciseTypeVersionAdapter } from '@datacamp/exercise-types';
var exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('ChatExercise', 'v1');
export default exerciseTypeVersionAdapter;